"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../data/store/store");
var setHasUserChangedLanguage_1 = require("../data/mutators/setHasUserChangedLanguage");
var owa_session_store_1 = require("owa-session-store");
var getFilteredDateFormatOptions_1 = require("../utils/getFilteredDateFormatOptions");
var getFilteredTimeFormatOptions_1 = require("../utils/getFilteredTimeFormatOptions");
var config_1 = require("owa-service/lib/config");
var setMailboxRegionalConfiguration_1 = require("../services/setMailboxRegionalConfiguration");
var owa_datetime_store_1 = require("owa-datetime-store");
var owa_options_core_1 = require("owa-options-core");
var owa_strings_1 = require("owa-strings");
var utilities_1 = require("@uifabric/utilities");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var getNewTimeZoneOffsets_1 = require("../services/getNewTimeZoneOffsets");
var loadTimeZoneOptions_1 = require("./loadTimeZoneOptions");
function saveRegionalOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _this = this;
        var optionState, _a, SessionSettings, UserOptions, languageHasChanged, newDateFormat, newTimeFormat, timeZoneHasChanged, newTimeZone, setMailboxRegionalConfigurationPromise, promises, language_1;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    optionState = store_1.default();
                    _a = owa_session_store_1.getUserConfiguration(), SessionSettings = _a.SessionSettings, UserOptions = _a.UserOptions;
                    languageHasChanged = optionState.selectedLocale !== null &&
                        optionState.selectedLocale !== SessionSettings.UserCulture;
                    owa_options_core_1.updateSessionSettings({
                        UserCulture: optionState.selectedLocale || SessionSettings.UserCulture,
                    });
                    newDateFormat = optionState.selectedDateFormat || UserOptions.DateFormat;
                    if (getFilteredDateFormatOptions_1.default().indexOf(newDateFormat) === -1) {
                        // The user changed locales to one that didn't support their previous date format, and didn't update the selection
                        // Default to the first option compatible with their locale
                        newDateFormat = getFilteredDateFormatOptions_1.default()[0];
                    }
                    owa_datetime_store_1.setDateFormat(newDateFormat);
                    newTimeFormat = optionState.selectedTimeFormat || UserOptions.TimeFormat;
                    if (getFilteredTimeFormatOptions_1.default().indexOf(newTimeFormat) === -1) {
                        // The user changed locales to one that didn't support their previous time format, and didn't update the selection
                        // Default to the first option compatible with their locale
                        newTimeFormat = getFilteredTimeFormatOptions_1.default()[0];
                    }
                    owa_datetime_store_1.setTimeFormat(newTimeFormat);
                    timeZoneHasChanged = !!optionState.selectedTimeZone && optionState.selectedTimeZone != UserOptions.TimeZone;
                    newTimeZone = optionState.selectedTimeZone || UserOptions.TimeZone;
                    config_1.setTimezone(newTimeZone);
                    // Save the new values to UserOptions
                    owa_options_core_1.updateUserOptions({
                        DateFormat: newDateFormat,
                        TimeFormat: newTimeFormat,
                        TimeZone: newTimeZone,
                    });
                    setMailboxRegionalConfigurationPromise = setMailboxRegionalConfiguration_1.default(SessionSettings.UserCulture, optionState.shouldRenameDefaultFolders, UserOptions.DateFormat, UserOptions.TimeFormat, UserOptions.TimeZone);
                    promises = [setMailboxRegionalConfigurationPromise];
                    // VSO:14100 - Rename the default folders, without pulling in mail code.
                    if (languageHasChanged) {
                        promises.push(setMailboxRegionalConfigurationPromise.then(loadTimeZoneOptions_1.default));
                        if (owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-localeHotReload')) {
                            language_1 = owa_strings_1.getSupportedFallbackForLocale(optionState.selectedLocale);
                            promises.push(owa_strings_1.setLocale(language_1.locale).then(function () { return utilities_1.setRTL(language_1.dir === 'rtl'); }));
                        }
                    }
                    if (timeZoneHasChanged) {
                        promises.push(setMailboxRegionalConfigurationPromise.then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var newTimeZoneOffsetType;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, getNewTimeZoneOffsets_1.default()];
                                    case 1:
                                        newTimeZoneOffsetType = _a.sent();
                                        owa_datetime_store_1.updateTimeZoneOffsets(newTimeZoneOffsetType);
                                        return [2 /*return*/];
                                }
                            });
                        }); }));
                    }
                    return [4 /*yield*/, Promise.all(promises)];
                case 1:
                    _b.sent();
                    if (languageHasChanged &&
                        (!owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-localeHotReload') || optionState.shouldRenameDefaultFolders)) {
                        setHasUserChangedLanguage_1.default(true);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = saveRegionalOption;
//# sourceMappingURL=saveRegionalOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/orchestration/saveRegionalOption.js
// module id = 4946
// module chunks = 2